import React from "react";
import { FaLock, FaEye, FaEyeSlash, FaUser, FaFacebook } from "react-icons/fa";
import { BiLogoGmail } from "react-icons/bi";
import { FcGoogle } from "react-icons/fc";
import { toast } from "react-toastify";
import { loginApi } from "../../services/AuthService";
import { loginConfirmedAction } from "../../store/actions/AuthActions";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";
import logo from "../../Images/dcwlogotext.png";

const AuthLogin1 = () => {
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPwd, setShowPwd] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ email: "", password: "" });

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  const handleKeyDownEmail = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (!email) {
        setErrors((prev) => ({ ...prev, email: "Email is required" }));
      } else {
        setErrors((prev) => ({ ...prev, email: "" }));
        passwordRef.current?.focus();
      }
    }
  };

  const handleKeyDownPassword = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (!password) {
        setErrors((prev) => ({ ...prev, password: "Password is required" }));
      } else {
        setErrors((prev) => ({ ...prev, password: "" }));
        onLogin(e);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") setEmail(value);
    if (name === "password") setPassword(value);
    setErrors({ ...errors, [name]: "" });
  };

  const onLogin = async (e) => {
    e.preventDefault();
    if (loading) return;

    let hasError = false;
    const errObj = { ...errors };
    if (!email) {
      errObj.email = "Email is required";
      hasError = true;
    }
    if (!password) {
      errObj.password = "Password is required";
      hasError = true;
    }
    setErrors(errObj);
    if (hasError) return;

    try {
      setLoading(true);
      const resp = await loginApi({ email, password });
      const { data, token } = resp.data;
      dispatch(loginConfirmedAction(data));
      navigate("/dashboard");
      if (process.env.REACT_APP_HEADER_TOKEN === "LOCALSTORAGE") {
        localStorage.setItem("TOKEN", token);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="loginpage">
        <div className="loginform">
          <div className="login-card shadow w-100 px-4 py-5 card rounded-3 overflow-hidden">
            <div>
              <div className="mb-3 d-flex justify-content-center align-items-center gap-1 logo-bounce">
                <img
                  src={logo}
                  alt="logoicon"
                  style={{ height: "45px", width: "auto" }}
                />
              </div>
              <p
                className="mb-3 fw-medium text-center"
                style={{
                  fontSize: "0.9rem",
                  color: "#979797",
                }}
              >
                Welcome back! Please sign in to continue.
              </p>
              <div className="mb-2">
                <label className="form-label" style={{ color: "#dad3d3eb" }}>
                  Email
                </label>
                <div className="position-relative">
                  <input
                    type="email"
                    ref={emailRef}
                    onChange={handleInputChange}
                    value={email}
                    name="email"
                    placeholder="Enter email"
                    className={`form-control custom-input px-5 ${
                      errors.email ? "is-invalid" : ""
                    }`}
                    onKeyDown={handleKeyDownEmail}
                  />
                  <FaUser
                    className="position-absolute top-50 translate-middle-y icon-float"
                    style={{
                      left: "15px",
                      pointerEvents: "none",
                      color: "#a6a6a6",
                    }}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label" style={{ color: "#dad3d3eb" }}>
                  Password
                </label>
                <div className="position-relative">
                  <input
                    ref={passwordRef}
                    type={showPwd ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    className={`form-control custom-input px-5 ${
                      errors.password ? "is-invalid" : ""
                    }`}
                    value={password}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDownPassword}
                  />
                  <FaLock
                    className="position-absolute top-50 translate-middle-y icon-float"
                    style={{
                      left: "15px",
                      pointerEvents: "none",
                      color: "#a6a6a6",
                    }}
                  />
                  <div
                    className="position-absolute top-50 translate-middle-y"
                    style={{
                      right: "15px",
                      cursor: "pointer",
                      color: "#a6a6a6",
                    }}
                    onClick={() => setShowPwd((prev) => !prev)}
                  >
                    {!errors?.password &&
                      (showPwd ? <FaEye /> : <FaEyeSlash />)}
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center gap-1">
                  <div className="form-check m-0 p-0 d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="rememberMe"
                      style={{
                        height: "0.9rem",
                        width: "0.9rem",
                        marginTop: "0",
                      }}
                    />
                  </div>
                  <label
                    htmlFor="rememberMe"
                    className="m-0"
                    style={{
                      fontSize: "0.9rem",
                      lineHeight: "1",
                      color: "#a6a6a6",
                    }}
                  >
                    Remember me
                  </label>
                </div>
                <span
                  className="cursor-pointer forgot-hover"
                  style={{ fontSize: "0.9rem", color: "#a6a6a6" }}
                >
                  Forgot password?
                </span>
              </div>

              <button

                className="btn btn-primary w-100 fw-semibold mb-3 animated-btn"

                disabled={loading}
                onClick={onLogin}
              >
                {loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Login to account"
                )}
              </button>

              {/* 
              <div className="mt-4 d-flex align-items-center w-100 gap-2">
                <div className="border flex-fill" />
                <span className="text-dark fw-bold fs-6">Or sign with</span>
                <div className="border flex-fill" />
              </div>
              <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
                <button className="btn rounded-2 btn-outline-light text-info" style={{ padding: "0.4rem 0.5rem" }}>
                  <FaFacebook size={21} />
                </button>
                <button className="btn btn-outline-light rounded-2" style={{ padding: "0.4rem 0.5rem" }}>
                  <FcGoogle size={21} />
                </button>
                <button className="btn btn-outline-light rounded-2 text-danger" style={{ padding: "0.4rem 0.5rem" }}>
                  <BiLogoGmail size={21} />
                </button>
              </div>

              <div className="d-flex justify-content-center align-items-center gap-1 mt-3">
                <span className="text-primary">Don’t have an account? </span>
                <button className="btn btn-link p-0" onClick={() => navigate("/register")}>
                  Register here
                </button>
              </div>
              */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthLogin1;
